export enum PasswordValidationStage {
  MinCharacter = 'Minimum of 12 characters',
  UpperCase = 'Must include an uppercase letter',
  LowerCase = 'Must include a lowercase letter',
  SpecialChar = 'Must include a special character',
  Number = 'Must include a number',
  NoSpace = 'Must not include space',
}
